'use client'

// imports
import { useSetAtom } from 'jotai';
import { useEffect, useRef } from 'react';

// lib files
import { getViewingHistory } from '@/lib/profile';
import { percentageWatchedViewingHistoryAtom } from '@/lib/atoms/viewing-history';
import { useIdentity } from '@/lib/hooks/useIdentity';

/**
 * Seeds the watched-percentage viewing history for the signed-in user.
 *
 * The uid comes from the confirmed profile, so it cannot be absent. Taking it
 * from pbs_uid threw NoUIDError, which the profile fetch read as an invalid
 * session and signed the user out on the next poll (sso-notes.txt Bug 1).
 */
const NetworkViewingHistory = () => {
  const { identity } = useIdentity()
  const setViewingHistory = useSetAtom(percentageWatchedViewingHistoryAtom)
  const requestedFor = useRef<string | null>(null)

  useEffect(() => {
    if (!identity) return
    // Once per uid per mount. A page load always confirms the session, so this
    // rides that: a navigation picks up changes, a tab left open does not.
    if (requestedFor.current === identity.uid) return

    requestedFor.current = identity.uid

    getViewingHistory(identity.uid)
      .then(setViewingHistory)
      .catch((error) => console.error('Unable to load viewing history', error))
  }, [identity, setViewingHistory])

  return null;
}

export default NetworkViewingHistory
